import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, Spin, Table } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector';
import { STATUS_NAME, VOUCHER_STATUS_DROPDOWN_OPTIONS } from 'src/models/vouchers';
import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney, wtFormatMoneyRoundData } from 'src/helpers/commons/utils';
import { wtSubYearsToDate } from 'src/helpers/commons/moment';
import WidgetDatePicker from 'src/widgets/DatePickers/WidgetDatePicker';
import { TYPE_GROUP, TYPE_TOTAL } from 'src/models/pnlConfig';
import { CaretDownFilled, CaretRightFilled, FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons'
import Pdf from './Pdf';
const BankBalanceReport = () => {
    const Base = new BaseListing('bank_balance_report')
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm();
    const [projects, setProjects] = useState([])
    const branches = wtGetFromLocalStorage("branches");
    const [projectId, setProjectId] = useState()
    const [projectName, setProjectName] = useState('')
    const [voucherStatus, setVoucherStatus] = useState()
    const [voucherStatusName, setVoucherStatusName] = useState('')
    const [branchId, setBranchId] = useState(0)
    const [branchName, setBranchName] = useState('')
    const [BankBalanceData, setBankBalanceData] = useState([])
    const [asOf, setAsOf] = useState('')
    const lastYearLastDate = asOf ? wtSubYearsToDate(asOf, 1, "YYYY-MM-DD") : '';
    const companyName = wtGetFromLocalStorage("company_name");
    const [boldRows, setBoldRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const BankBalanceReportColumns = [

        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Sr#</span>,
            dataIndex: 'sr_no',
            key: 'sr_no',
            align: 'center', // Center-align the serial number
            width: "5%",
            render: (text, record, index) => index + 1 // Display serial number starting from 1
        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Bank Name</span>,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
            width: "20%",
            render: (text, record) => record.bank.name// Display serial number starting from 1


        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Branch Name</span>,
            dataIndex: 'bank_branch_name',
            key: 'bank_branch_name',
            align: 'left',
            width: "20%",
        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Account No</span>,
            dataIndex: 'account_no',
            key: 'account_no',
            align: 'left',
            width: "15%",

        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Closing Balance In Bank</span>,
            dataIndex: 'balance',
            key: 'balance',
            align: 'center',
            width: "10%",
            render: (balance) => wtFormatMoney(balance, "", false, 2)


        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Lien Marked By Bank For B.G/LC</span>,
            dataIndex: 'lien_balance',
            key: 'lien_balance',
            align: 'center',
            width: "10%",
            render: (lien_balance) => wtFormatMoney(lien_balance, "", false, 2)

        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Margin Against LCC</span>,
            dataIndex: 'margin_against_lc',
            key: 'margin_against_lc',
            align: 'center',
            width: "10%",
            render: (margin_against_lc) => wtFormatMoney(margin_against_lc, "", false, 2)

        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Closing Balance</span>,
            dataIndex: 'closing_balance',
            key: 'closing_balance',
            align: 'center',
            width: "10%",
            render: (closing_balance) => <span style={{ color: 'blue' }}> {wtFormatMoney(closing_balance, "", false, 2)}</span>

        },

    ];

    const print = () => {
        setIsLoading(true)
        wtApiPostWithContentTypeHandling('reports/bank_balance/print', {
            branch_id: branchId,
            as_of: asOf,
            project_id: projectId,
            voucher_status: voucherStatus,
            status: 1,
        });
        setIsLoading(false)
    }


    const changeValues = (key, val) => {

        //Set initial values
        setBankBalanceData([]);

        if (key === 'branch_id') {
            setBranchId(val.value)
            setBranchName(val.label)
        }
        if (key === 'project_id') {
            setProjectId(val)
            if (val === '') {
                setProjectName('');
            }
        }
        if (key === 'voucher_status') {
            setVoucherStatus(val.value)
            setVoucherStatusName(val.label)
        }
        if (key === 'as_of') {
            setAsOf(val);
        }
    }

    useEffect(() => {
        Base.dropdownData('projects', {}, [setProjects], 1)
    }, [])

    const getReportData = () => {
        setIsLoading(true);
        wtApiCall(
            'reports/bank_balance_report',
            {
                as_of: asOf,
                last_year: lastYearLastDate,
                branch_id: branchId,
                project_id: projectId,
                voucher_status: voucherStatus,
                status: 1,
                version: 1
            },
            'get',
            (response) => {

                //set data
                if (response !== null) {
                    if (response.data !== null) {
                        if (response) {
                            setBankBalanceData(response.data);
                        }
                        else {
                            //Set initial values
                            setBankBalanceData([]);
                        }
                    }
                }

                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );

    };



    const totalBalance = BankBalanceData.reduce((sum, record) => sum + (parseFloat(record.balance) || 0), 0);
    const totalLienBalance = BankBalanceData.reduce((sum, record) => sum + (parseFloat(record.lien_balance) || 0), 0);
    const totalClosingBalance = BankBalanceData.reduce((sum, record) => sum + (parseFloat(record.closing_balance) || 0), 0);
    const totalMarginAgainstLC = BankBalanceData.reduce((sum, record) => sum + (parseFloat(record.margin_against_lc) || 0), 0);


    return (
        <div className='container-fluid' style={{
            padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica",
        }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card title={<span style={{ fontSize: '22px', marginLeft: "40%" }}>Bank Balance Report</span>} style={{ width: "100%" }}>
                    <Row gutter={[16, 16]}>
                        <Col xs={4} sm={2} md={1}></Col>
                        <Col xs={15} sm={10} md={4}>
                            <label>As Of: *</label>
                            <WidgetDatePicker
                                value={asOf}
                                setDate={setAsOf}
                                placeholder="As Of"
                            />
                        </Col>
                        <Col xs={12} sm={8} md={4}>
                            <label>Voucher Status:</label>
                            <WidgetSelector
                                selectedValue={voucherStatus}
                                displayValue={voucherStatusName}
                                options={VOUCHER_STATUS_DROPDOWN_OPTIONS}
                                showCloudIcon={false}
                                size={"md"}
                                onChange={(values) => changeValues("voucher_status", values)}
                            />
                        </Col>
                        <Col xs={18} sm={12} md={6}>
                            <label>Branch:</label>
                            <WidgetBranchSelector
                                value={branchId}
                                displayValue={branchName}
                                branches={branches}
                                placeholder="Select Branch"
                                onChange={(values) => changeValues('branch_id', values)}
                                showCloudIcon={false}
                            />

                        </Col>
                        <Col xs={18} sm={12} md={6}>
                            <label>Project: </label>
                            <WidgetProjectSelector
                                onChange={(value) => changeValues('project_id', value)}
                                data={projects}
                                value={projectId}
                                displayValue={projectName}
                                height={35}
                                reloadDropdownData={() => Base.dropdownData('projects', {}, [setProjects], 1)}
                            />
                        </Col>

                        <Col xs={8} sm={4} md={2}>
                            <Button style={{ marginTop: 35 }} type="primary" htmlType="submit" disabled={isLoading ? true : false}>Search</Button>
                            {Base.hasRights('Print Bank Balance') &&
                                <Button style={{ marginTop: 30, backgroundColor: "red", color: "#fff" }} onClick={print} disabled={isLoading ? true : false}>Print</Button>
                            }
                        </Col>
                    </Row>
                </Card>

                <br /><br />
                <div style={{ overflow: 'auto', margin: "auto", width: "90%" }}>

                    <label htmlFor="">* Note: All the amounts are in Million rupees</label>

                    <Table
                        columns={BankBalanceReportColumns}
                        dataSource={BankBalanceData}
                        pagination={false}
                        scroll={{ x: 'max-content' }}
                        summary={() => (
                            <Table.Summary.Row style={{ fontWeight: 'bold', textAlign: 'center', }}>
                                <Table.Summary.Cell index={0} colSpan={4}>
                                    <strong>Total</strong>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    {wtFormatMoney(totalBalance, "", false, 2)}
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>
                                    {wtFormatMoney(totalLienBalance, "", false, 2)}
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>
                                    {wtFormatMoney(totalMarginAgainstLC, "", false, 2)}
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>
                                    {wtFormatMoney(totalClosingBalance, "", false, 2)}
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        )}
                        bordered
                        size="small"
                        loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
                    />
                </div>

            </Form >
        </div >
    );
};

export default BankBalanceReport;
